import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import OfflineIndicator from "@/components/OfflineIndicator";
import Landing from "@/pages/Landing";
import EventsList from "@/pages/EventsList";
import EventDetail from "@/pages/EventDetail";

function AppShell() {
  const location = useLocation();
  const isLanding = location.pathname === "/";
  return (
    <>
      {!isLanding && <Header />}
      <main className="relative z-10">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/eventos" element={<EventsList />} />
          <Route path="/evento/:id" element={<EventDetail />} />
        </Routes>
      </main>
      <OfflineIndicator />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppShell />
        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={{
            style: {
              background: "#0F172A",
              border: "1px solid #1E293B",
              color: "#FFFFFF",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
